export const MODULE_NAME = {
  MODULE_HOME: 'Home',
  MODULE_ACCOUNT_INFO: 'Account Info',
  MODULE_LIST_BIDING: 'List Bidding',
  MODULE_ESTATE_INFO: 'Estate Info',
  MODULE_SELLER_INFO: 'Seller Infor',
  MODULE_MESSAGE: 'Message',
  MODULE_VIOLATION_REPORT: 'Violation Report',
  MODULE_ESTATE_DETAIL_SELLER: 'Estate Detail Seller',
  MODULE_BIDDER_INFO: 'Bidder Info',
  MODULE_ESTATE_EDIT: 'Estate Edit',
  MODULE_ESTATE_DELETE: 'Estate Delete',
  MODULE_ESTATE_CREATE: 'Estate Create',
  MODULE_OPTION: 'Option',
  MODULE_NEWS: 'News',
  MODULE_ADVERTISING_OPTION: 'Advertising Option',
  MODULE_ERRORS: 'Errors',
  MODULE_SEARCH: 'Search',
  MODULE_HELP: 'Help',
  MODULE_INQUIRY: 'Inquiry',
  MODULE_TERM_OF_SERVICE: 'Term Of Service'
};
